export const DESKTOP_MIN_WIDTH = 1025;
export const DESKTOP_MIDDLE_MIN_WIDTH = 1281;
